module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"dk":{"homeTitle":"Intersolia Danmark - Din partner i miljøledelse"}}')
  delete Component.options._Ctor
}
